import { API, graphqlOperation } from "aws-amplify";
import { deleteComment as deleteCommentMutation } from "../graphql/mutations";

export default async function deleteComment(id) {
    let res = await API.graphql(graphqlOperation(deleteCommentMutation, { input: { id } }));
    return res;
}